export const getErrors = (state) => {
  const error =
    state.project.error ||
    state.workspace.error ||
    state.tenant.error ||
    state.tenants.error;
  return error ? error : false;
};
